var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pb-0",attrs:{"cols":"12"}},[_c('small',[_vm._v(" "+_vm._s(_vm.$t('components.requiredFields.fieldsMarkedWith'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" "+_vm._s(_vm.$t('components.requiredFields.areRequired'))+". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }